import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  CCarousel,
  CCarouselItem,
  CImage,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../Loading/Loading";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { CButton } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilSettings } from "@coreui/icons";
import { cilTrash } from "@coreui/icons";

const ObjectDetails = ({ object, onClose }) => {
  const [images, setImages] = useState([]);
  const [isMapLoaded, setIsMapLoaded] = useState(false); // Состояние для отслеживания загрузки карты
  const mapContainerRef = useRef();
  const token = localStorage.getItem("token");
  const [ai_images, setAiImages] = useState([]);
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPhotoDescription, setCurrentPhotoDescription] = useState("");
  const [ai_image_now, setAi_image_now] = useState(null);
  const [showMarkers, setShowMarkers] = useState(true);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Функция для удаления объекта

  const openPhotoModal = (src) => {
    setCurrentPhoto(src);
    setPhotoModalOpen(true);
  };

  const closePhotoModal = () => {
    setCurrentPhoto(null);
    setPhotoModalOpen(false);
  };

  const CustomImagePreviewer = (path_file, imageData) => {
    setLoading(true);
    // Convert the object to a string
    const objectString = JSON.stringify(imageData, null, 2);
    setCurrentPhotoDescription(objectString);
    setAi_image_now(imageData);
    axios
      .get(
        `/api/ldoc/${object.LDoc}/workdir/preview/?path=${encodeURIComponent(
          path_file
        )}`,
        { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }
      )
      .then((res) => {
        const b = new Blob([res.data]);
        openPhotoModal(URL.createObjectURL(b));
        setLoading(false);
      })
      .catch(() => {
        toast.error(`Невозможно просмотреть "${path_file}"`);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (object?.LDoc) {
      axios
        .get(`/api/ldoc/${object.LDoc}/images/`, {
          headers: {
            Authorization: `Bearer ${token}`, // Добавляем токен в заголовок
          },
        })
        .then((response) => {
          setImages(response.data.images || []);
        })
        .catch((error) => {});
    }
  }, [object?.LDoc]);

  useEffect(() => {
    axios
      .get(`/api/ldoc/${object.LDoc}/aidefects/`, {
        headers: {
          Authorization: `Bearer ${token}`, // Добавляем токен в заголовок
        },
      })
      .then((response) => {
        setAiImages(response.data);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    const container = mapContainerRef.current;
    if (container) {
      if (!showMarkers) {
        container.classList.add("hide-markers");
      } else {
        container.classList.remove("hide-markers");
      }
    }
  }, [showMarkers]);

  useEffect(() => {
    if (isMapLoaded && object) {
      mapboxgl.accessToken =
        "pk.eyJ1IjoiYml0Y29kZTIxIiwiYSI6ImNtOWUzMXc0NzB3ZWQyb3F3YXZtcHNpMzkifQ.KnaO2bWRSnlCBTeu6EHyIQ";
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        zoom: 15,
        pitch: 42,
        center: [object.CoordLng, object.CoordLat],
        style: "mapbox://styles/bitcode21/cm9l7pvii00x101r32qxwdvel",
      });

      map.addControl(new mapboxgl.FullscreenControl());

      map.on("style.load", () => {
        map.addSource("model", {
          type: "geojson",
          data: {
            type: "Feature",
            properties: {
              "model-uri": `https://lk.soyzstal.ru/3d/${object.LDoc}`,
            },
            geometry: {
              coordinates: [object.CoordLng, object.CoordLat],
              type: "Point",
            },
          },
        });

        let rotate = object.CoordRotate || 0.0;

        map.addLayer({
          id: "tower",
          type: "model",
          slot: "middle",
          source: "model",
          minzoom: 10,
          layout: {
            "model-id": ["get", "model-uri"],
          },
          paint: {
            "model-opacity": 1,
            "model-rotation": [0.0, 0.0, rotate],
            "model-scale": [1, 1, 1],
            "model-color-mix-intensity": 0,
            "model-cast-shadows": true,
            "model-emissive-strength": 0.8,
          },
        });
      });

      map.on("load", function () {
        map.resize();
        let height = object.CoordHeight || 0.0;
        Object.keys(ai_images).forEach((imagePath) => {
          const imageData = ai_images[imagePath];
          let marker = new mapboxgl.Marker({
            altitude: imageData.Altitude - height,
            className: "markdef1",
            color: imageData.Color || "#000",
          })
            .setLngLat([imageData.CoordLng, imageData.CoordLat])
            .addTo(map);
          marker
            .getElement()
            .addEventListener("click", (e) =>
              CustomImagePreviewer(imagePath, imageData)
            );
        });
      });
    }
  }, [isMapLoaded, object]);

  const handleLoadMap = () => {
    setIsMapLoaded(true); // Загрузка карты при нажатии на кнопку
  };

  const handleDeleteObject = async () => {
    if (!object?.LineListID) {
      console.error("LineListID отсутствует");
      return;
    }

    setDeleteLoading(true);

    try {
      const response = await axios.delete(
        `/api/objects/line-list/?id=${object.LineListID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        alert("Объект успешно удален");
        // Закрываем модальное окно и вызываем onClose для обновления таблицы
        setShowDeleteModal(false);
        if (onClose) {
          onClose();
        }
      } else {
        console.error("Ошибка при удалении:", response.data);
        alert(
          "Ошибка при удалении объекта: " +
            (response.data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      console.error("Ошибка при удалении:", error);
      if (error.response) {
        alert(
          "Ошибка при удалении объекта: " +
            (error.response.data?.message || error.response.statusText)
        );
      } else {
        alert("Ошибка при удалении объекта: " + error.message);
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  if (!object) return null;

  // ИСПРАВЛЕНО: Убрано жесткое ограничение maxHeight, чтобы модальное окно не обрезалось и не добавляло лишний скролл
  const delmodalStyle = {
    // maxHeight: "25vh", // Убрано для исправления бага с прокруткой
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div className="structura_tab_flex">
      {loading && <Loading name="Открытие файла" />}
      <div className="info_object">
        <h5>Общие данные</h5>
        <p>
          <strong>Дата изменения документации:</strong> {object.DateChanged}
        </p>
        <p>
          <strong>Регион:</strong> {object.Region}
        </p>
        <p>
          <strong>Адрес объекта:</strong> {object.Address}
        </p>
        <p>
          <strong>Тип собственности:</strong> {object.OwnershipType}
        </p>
        <p>
          <strong>Статус объекта:</strong> {object.ObjectStatus}
        </p>
        <p>
          <strong>Год возведения объекта:</strong> {object.BuildYear}
        </p>
        <p>
          <strong>Тип проекта объекта:</strong> {object.ProjectType}
        </p>
        <p>
          <strong>Проектная организация:</strong> {object.DesignOrg}
        </p>
        <p>
          <strong>Год и характер капитального ремонта:</strong>{" "}
          {object.LastRepair}
        </p>
        <p>
          <strong>Уровень ответственности объекта:</strong>{" "}
          {object.ResponsibilityLevel}
        </p>

        <h5 style={{ marginTop: "1rem" }}>Договор</h5>
        <p>
          <strong>Наименование договора:</strong> {object.ContractName}
        </p>
        <p>
          <strong>Наименование работы:</strong> {object.WorkName}
        </p>
        <p>
          <strong>Шифр работы:</strong> {object.WorkCipher}
        </p>
        <p>
          <strong>Номер договора:</strong> {object.ContractNumber}
        </p>
        <p>
          <strong>Дата договора:</strong> {object.ContractDate}
        </p>
        <p>
          <strong>Дата окончания:</strong> {object.EndDate}
        </p>
        <p>
          <strong>Техническое задание:</strong> {object.TechTask}
        </p>
        {/* Кнопка удаления объекта внизу слева */}
        <div
          className="delete-button-container"
          style={{ padding: "40", textAlign: "left" }}
        >
          <button
            className="button button-delete"
            onClick={() => setShowDeleteModal(true)}
            disabled={deleteLoading}
          >
            <CIcon customClassName="button-delete__svg" icon={cilTrash} />
            Удалить объект
          </button>
        </div>
      </div>

      <div>
        <CCarousel controls indicators>
          {images.map((img, idx) => (
            <CCarouselItem key={idx}>
              <CImage
                className="d-block structura_img_600px"
                src={`${img.replace("pathtofiles/", `pathtofiles/${token}/`)}`}
                alt={`Slide ${idx + 1}`}
              />
            </CCarouselItem>
          ))}
        </CCarousel>

        {!object.CoordLat || !object.CoordLng ? null : (
          <div style={{ marginTop: "50px" }}>
            <CButton
              onClick={() => setSettingsModalOpen(true)}
              className="setting-map"
            >
              <CIcon icon={cilSettings} className="me-2" />
            </CButton>
            {!isMapLoaded ? (
              <div className="map-button-container">
                <button onClick={handleLoadMap}>Загрузить карту</button>
              </div>
            ) : (
              <div
                id="map-container"
                ref={mapContainerRef}
                style={{ width: "100%", height: "400px" }}
              />
            )}
          </div>
        )}
      </div>

      {/* Модальное окно для настройки отображения маркеров */}
      <CModal
        visible={settingsModalOpen}
        onClose={() => setSettingsModalOpen(false)}
      >
        <CModalHeader>
          <CModalTitle>Настройка отображения маркеров</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ textAlign: "center" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <label>
              <input
                type="checkbox"
                checked={showMarkers}
                onChange={(e) => setShowMarkers(e.target.checked)}
                defaultChecked={true}
              />
              Включить маркеры
            </label>
          </div>
        </CModalBody>
      </CModal>
      {/* Модальное окно для фото */}
      <CModal
        visible={photoModalOpen}
        onClose={closePhotoModal}
        size="lg"
        className="photo-modal"
      >
        <CModalHeader onClose={closePhotoModal}>
          <CModalTitle>
            Просмотр фотографии (Высота: {ai_image_now?.Altitude} м.)
          </CModalTitle>
        </CModalHeader>
        <CModalBody style={{ textAlign: "center" }}>
          {currentPhoto && (
            <img
              src={currentPhoto}
              alt="Увеличенное фото"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          )}
          <SyntaxHighlighter language="json" style={atomDark}>
            {currentPhotoDescription}
          </SyntaxHighlighter>
        </CModalBody>
      </CModal>

      {/* Модальное окно подтверждения удаления */}
      <CModal
        visible={showDeleteModal}
        style={delmodalStyle}
        onClose={() => !deleteLoading && setShowDeleteModal(false)}
      >
        <CModalHeader>
          <CModalTitle>Подтверждение удаления</CModalTitle>
        </CModalHeader>
        <CModalBody>
          Вы уверены, что хотите удалить объект? Это действие нельзя отменить.
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            onClick={() => setShowDeleteModal(false)}
            disabled={deleteLoading}
          >
            Отмена
          </CButton>
          <CButton
            color="danger"
            onClick={handleDeleteObject}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Удаление..." : "Да, удалить"}
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default ObjectDetails;